export default __webpack_public_path__ + "static/media/prands.fc7c9e18.png";